module.exports = __webpack_public_path__ + "9788f41e/img/lock-icon.bb9c7166.svg";